import CategoryListPage from "@/pages/category/components/CategoryListPage";
import { movieList } from "@/lib/media";

export default function MovieCategory() {
  return (
    <CategoryListPage
      title="电影列表"
      description="汇集院线新片、经典佳作与类型精选。可按类型、年份、地区自由组合筛选，快速找到你想看的电影。以下内容为影视资讯与内容介绍展示，不含真实播放资源。"
      breadcrumbLabel="电影"
      list={movieList}
      type="movie"
    />
  );
}